<template>
  <Modal :closeOnClickOutside="closeOnClickOutside" :isOpen="isOpen">
    <div class="confirm-dialog">
      <div class="image-wrapper">
        <img class="promotion-image" src="@static/img/promotion.gif" alt="ChangedCountry" />
      </div>
      <div class="title" data-testid="title">New ePayment Mobile Website  🎉</div>
      <div class="message" data-testid="message">
        We've released the upgraded ePayment mobile website, ensuring a seamless and improved user experience for all transactions.
        <span style="display: block">
          Would you like to give it a try?
        </span>
      </div>
      <div class="buttons d-flex">
        <EpButton class="confirm-button" @click="$emit('discard')" variant="outlined" color="secondary">Stay Here</EpButton>
        <EpButton
          class="discard-button"
          @click="$emit('confirm')"
        >
          Continue
        </EpButton>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from '@/components/Modal.vue'
import EpButton from '@/components/EpButton.vue'

export default {
  components: { Modal, EpButton },

  props: {
    isOpen: {
      type: Boolean,
      required: true
    },

    closeOnClickOutside: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.confirm-dialog {
  background-color: #fff;
  width: 343px;
  border-radius: 5px;
  border: 1px solid #f1f1f1;
  padding: 0 24px 24px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: center;

  .image-wrapper {
    width: 342px;
    height: 177px;
    display: contents;
    background: #fdf2f1;
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;

    .promotion-image {
      width: 342px;
      height: 177px;
      border-top-right-radius: 5px;
      border-top-left-radius: 5px;
      animation: fadeIn 1s ease-in;
    }
  }

  .title {
    font-weight: 600;
    font-size: 16px;
    color: #000;
    margin-top: 24px;
    line-height: 20px;
  }

  .message {
    margin-top: 8px;
    text-align: center;
    line-height: 18px;
    font-weight: 400;
    font-size: 14px;
  }

  .buttons {
    margin-top: 24px;
    width: 100%;
    justify-content: center;
    gap: 16px;
  }

  .discard-button {
    width: 100%;
  }

  .confirm-button {
    width: 100%;
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
